export default __webpack_public_path__ + "static/media/down.543f2b6f.svg";